import { createApp } from 'vue'
import App           from "./components/App";
import store         from "./store";

function onReady ()
{

    const articlesContainers = document.querySelectorAll( '.articles-index-module' );

    // no container? no honey
    if ( articlesContainers.length === 0 )
    {
        return;
    }


    Array.from( articlesContainers )
        .forEach( el =>
        {

            const articleIndex = createApp( App );

            articleIndex
                .use( store )
                .provide( "articles", vueArticlesArticles ) //inject in JS from PHP
                .provide( "categories", vueArticlesArticleCategories ) //inject in JS from PHP
                .provide( "copydeck", vueArticlesCopydeck ) //inject in JS from PHP
                .provide( "pageTitle", vueArticlesPageTitle ) //inject in JS from PHP
                .mount( el );

        } )
}


document.addEventListener( 'DOMContentLoaded', onReady );


